export default __webpack_public_path__ + "static/media/assetto-corsa.601feda2.png";